export const requestHelp = [
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'subject',
        label: 'Subject *',
        placeholder: 'John Smith',
        type: 'text',
      },
    ],
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'contactName',
        label: 'Client Name *',
        placeholder: 'John Smith',
        type: 'text',
      },
    ],
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'contactEmail',
        label: 'Client Email *',
        placeholder: 'johnsmith@example.com',
        type: 'text',
      },
    ],
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'message',
        label: 'ATTACH AN OPTIONAL MESSAGE TO YOUR REQUEST',
        labelIcon: 'notes',
        placeholder:
          'Add specific details of what is being requested or why this detail is required, for example a specific document required, or section you’d like the client to complete',
        rows: '5',
        subLabel: '(Optional)',
        type: 'textarea',
      },
    ],
  },
];
